import { Outlet, createRoute, redirect } from "@tanstack/react-router"
import { isAxiosError } from "axios"

import { rootRoute } from "@/App"
import { queryClient } from "@/lib/query-client"
import { getGetAuthUserQueryOptions } from "openapi/api/endpoints"

async function requireAuthenticatedUser() {
  try {
    const user = await queryClient.ensureQueryData(
      getGetAuthUserQueryOptions({
        query: {
          retry: false,
          staleTime: 60_000,
        },
      }),
    )

    if (user) return
  } catch (error) {
    // 403 means signed in but a member of no organization: explain, don't bounce to sign-in.
    if (isAxiosError(error) && error.response?.status === 403) {
      throw redirect({ to: "/no-access", replace: true })
    }
    // Otherwise the generated auth query threw on 401; redirect below.
  }

  throw redirect({ to: "/authentication", replace: true })
}

function AuthenticatedOutlet() {
  return <Outlet />
}

const AuthenticatedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "authenticated",
  beforeLoad: requireAuthenticatedUser,
  component: AuthenticatedOutlet,
})

export default AuthenticatedRoute
